/* Coria invoice: stable inputs, serialized saves, verified CUI lookup, checkout gate. */
(function () {
  'use strict';
  if (window.CoriaInvoice) return;
  var cfg = window.CORIA_INVOICE || {};
  if (!cfg.enabled) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var keys = ['Firma - CUI', 'Firma - denumire', 'Firma - Nr. Reg. Com.', 'Firma - sediu'];
  var labels = ['CUI (cod fiscal)', 'Denumire firmă / salon', 'Nr. Reg. Com. (opțional)', 'Adresa sediului social'];
  var values = {}, fieldRev = {}, revision = 0, savedRevision = 0, saving = null, timer = 0;
  var lookupTimer = 0, lookupController, lookupPromise = Promise.resolve(), lookupId = 0, source = '';
  var checkoutBusy = false, forms = new Set(), STORAGE = 'coria_invoice_draft_v2';
  var draft = null;
  try { draft = JSON.parse(sessionStorage.getItem(STORAGE) || 'null'); } catch (_) {}
  if (draft && draft.values && Date.now() - draft.at < 12 * 3600000) {
    keys.forEach(function (k) { values[k] = String(draft.values[k] || '').slice(0, 250); });
    revision = 1;
  }
  function persist() { try { sessionStorage.setItem(STORAGE, JSON.stringify({values:values,at:Date.now()})); } catch (_) {} }
  function normalize(v) { return String(v || '').toUpperCase().replace(/\s/g, '').replace(/^RO/, ''); }
  function valid(v) {
    v = normalize(v); if (!/^[1-9]\d{1,9}$/.test(v)) return false;
    var d = v.slice(0,-1).padStart(9,'0'), weights='753217532', sum=0;
    for(var i=0;i<9;i++)sum+=Number(d[i])*Number(weights[i]);
    return ((sum*10)%11)%10 === Number(v.slice(-1));
  }
  function each(cb) { forms.forEach(function (form) { if (!form.isConnected) forms.delete(form); else cb(form); }); }
  function message(text, bad) { each(function (f) { var m=f.querySelector('.cf-inv__msg'); m.textContent=text; m.classList.toggle('is-bad',!!bad); }); }
  function sync() { each(function (f) { f.querySelectorAll('input[data-k]').forEach(function (input) { if (input !== document.activeElement) input.value=values[input.dataset.k]||''; }); }); }
  function hasData() { return keys.some(function(k){return !!String(values[k]||'').trim();}); }
  var loaded = fetch(root+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}})
    .then(function(r){if(!r.ok)throw new Error();return r.json();})
    .then(function(cart){if(revision===0){keys.forEach(function(k){values[k]=String((cart.attributes||{})[k]||'');});source=(cart.attributes||{})['Firma - sursa verificare']||'';sync();}})
    .catch(function(){/* An existing draft can still be saved with cart/update. */});
  function snapshot() {
    var attrs={}; keys.forEach(function(k){attrs[k]=String(values[k]||'').trim();});
    attrs['Factura pe firma']=hasData()?'Da':'';
    attrs['Firma - sursa verificare']=source;
    return attrs;
  }
  async function flush() {
    clearTimeout(timer); await loaded;
    if(saving){await saving; if(savedRevision<revision)return flush(); return;}
    if(savedRevision>=revision)return;
    saving=(async function(){
      while(savedRevision<revision){
        var at=revision, attrs=snapshot(), controller=new AbortController();
        var timeout=setTimeout(function(){controller.abort();},12000);
        try {
          var r=await fetch(root+'cart/update.js',{method:'POST',credentials:'same-origin',signal:controller.signal,headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:attrs})});
          if(!r.ok)throw new Error('Datele firmei nu au putut fi salvate.');
          var cart=await r.json();
          if(!cart.attributes || keys.some(function(k){return String(cart.attributes[k]||'')!==attrs[k];}))throw new Error('Salvarea datelor nu a fost confirmată.');
          savedRevision=at;
        } finally {clearTimeout(timeout);}
      }
      message(hasData()?'Datele firmei sunt salvate pentru facturarea comenzii.':'');
    })();
    try {await saving;} catch(error) { if(window.CoriaCommerce)CoriaCommerce.track('invoice_save_error',{mode:'invoice'}); throw error; } finally {saving=null;}
  }
  function saveSoon(){clearTimeout(timer);timer=setTimeout(function(){flush().catch(function(){message('Nu am putut salva încă. Reîncercăm când apeși Finalizează comanda.',true);});},900);}
  async function lookup(cui, id) {
    if (!cfg.endpoint || !valid(cui)) return;
    var endpoint; try{endpoint=new URL(cfg.endpoint,location.origin);if(endpoint.protocol!=='https:')return;}catch(_){return;}
    var startRev=Object.assign({},fieldRev);
    var controller=new AbortController();lookupController=controller;
    var timeout=setTimeout(function(){controller.abort();},10000);
    message('Caut datele firmei…');
    try {
      var r=await fetch(endpoint.href,{method:'POST',signal:controller.signal,credentials:'omit',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({cui:normalize(cui)})});
      if(!r.ok)throw new Error();var result=await r.json();
      if(id!==lookupId || normalize(values[keys[0]])!==normalize(cui))return;
      if(!result.company || String(result.company.cui)!==normalize(cui) || result.source!=='ANAF')throw new Error();
      var company=result.company, map={};map[keys[1]]=company.name;map[keys[2]]=company.registration;map[keys[3]]=company.address;
      var edited=false;
      Object.keys(map).forEach(function(k){if(fieldRev[k]!==startRev[k]){edited=true;return;}if(map[k])values[k]=String(map[k]).slice(0,250);});
      source=edited?'':'ANAF · '+String(result.checkedAt||'').slice(0,10);revision++;persist();sync();saveSoon();
      message('Date preluate din ANAF. Verifică denumirea și sediul înainte de finalizare.');
    } catch(e) {if(id===lookupId)message('Nu am putut verifica firma acum. Poți completa manual datele.',true);}
    finally {clearTimeout(timeout);}
  }
  function queueLookup() {
    clearTimeout(lookupTimer);if(lookupController)lookupController.abort();var id=++lookupId;
    var cui=values[keys[0]];
    if(!cfg.endpoint || !valid(cui))return;
    lookupTimer=setTimeout(function(){lookupPromise=lookup(cui,id);},900);
  }
  function makeForm(){
    var d=document.createElement('details');d.className='cf-inv';d.dataset.cfInv='';
    var summary=document.createElement('summary');summary.textContent='Vreau factură pe firmă';d.appendChild(summary);
    var grid=document.createElement('div');grid.className='cf-inv__grid';d.appendChild(grid);
    keys.forEach(function(k,i){var label=document.createElement('label');label.textContent=labels[i];var input=document.createElement('input');input.type='text';input.dataset.k=k;input.name='attributes['+k+']';input.maxLength=i===0?14:250;input.autocomplete=i===1?'organization':i===3?'street-address':'off';input.value=values[k]||'';label.appendChild(input);grid.appendChild(label);});
    var msg=document.createElement('p');msg.className='cf-inv__msg';msg.setAttribute('role','status');grid.appendChild(msg);
    var reset=document.createElement('button');reset.type='button';reset.className='cf-inv__reset';reset.textContent='Renunță la factura pe firmă';grid.appendChild(reset);
    reset.addEventListener('click',function(){clearTimeout(lookupTimer);if(lookupController)lookupController.abort();lookupId++;keys.forEach(function(k){values[k]='';fieldRev[k]=++revision;});source='';persist();sync();each(function(f){f.open=false;});saveSoon();});
    d.addEventListener('input',function(e){var k=e.target.dataset.k;if(!k)return;values[k]=e.target.value;fieldRev[k]=++revision;source='';persist();sync();saveSoon();if(k===keys[0])queueLookup();});
    d.addEventListener('focusin',function(){if(window.CoriaAssistantBridge)CoriaAssistantBridge.quiet(60000, true);});
    d.addEventListener('toggle',function(){if(d.open && cfg.endpoint && valid(values[keys[0]])&&!source)queueLookup();});
    forms.add(d);loaded.then(function(){if(!d.isConnected)return;sync();if(hasData())d.open=true;});
    return d;
  }
  var selector='button[name="checkout"],input[name="checkout"],a[href*="checkout"]';
  function isCheckout(el){if(!el)return false;if(el.matches('[name="checkout"]'))return true;if(el.tagName!=='A')return false;try{var u=new URL(el.href,location.href);return u.origin===location.origin && /\/checkout\/?$/.test(u.pathname);}catch(_){return false;}}
  function place(){
    document.querySelectorAll(selector).forEach(function(btn){
      if(!isCheckout(btn))return;
      if(btn.closest('.cb-bubble,.cbs-actions,.cbs-holo,.cbs-cta,.cbs-cart'))return;
      var actions=btn.closest('.cbs-cta,.cqo-links,.cart__ctas')||btn.parentElement;
      if(!actions || actions.closest('[data-cf-inv]'))return;
      var host=actions.parentElement;if(!host)return;
      if(!host.querySelector(':scope > [data-cf-inv]'))host.insertBefore(makeForm(),actions);
    });
  }
  /* precompleteaza in checkout campul "Companie / CUI" (livrare + facturare), ca clientul sa nu-l scrie de doua ori */
  function checkoutUrl(){
    var name=String(values[keys[1]]||'').trim(), cui=String(values[keys[0]]||'').trim().toUpperCase().replace(/\s/g,'');
    if(!name)return root+'checkout';
    var company=(name+(cui?' - CUI '+cui:'')).slice(0,250);
    var q='checkout[shipping_address][company]='+encodeURIComponent(company)+'&checkout[billing_address][company]='+encodeURIComponent(company);
    return root+'checkout?'+q;
  }
  function validate(){if(!hasData())return true;return valid(values[keys[0]])&&!!String(values[keys[1]]||'').trim()&&!!String(values[keys[3]]||'').trim();}
  async function checkout(btn){
    if(checkoutBusy)return;checkoutBusy=true;
    var text=btn.textContent;btn.setAttribute('aria-busy','true');if(btn.tagName==='BUTTON'||btn.tagName==='INPUT')btn.disabled=true;
    try{
      await loaded;
      clearTimeout(lookupTimer);
      if(cfg.endpoint && valid(values[keys[0]])&&!source){if(lookupController)lookupController.abort();lookupPromise=lookup(values[keys[0]],++lookupId);}
      await lookupPromise;
      if(!validate()){
        each(function(f){f.open=true;});message('Completează un CUI valid, denumirea firmei și adresa sediului.',true);
        var form=btn.closest('.cbs-foot,.cqo-body,.cart--footer')?.querySelector('[data-cf-inv]')||document.querySelector('[data-cf-inv]');
        if(form){form.open=true;form.scrollIntoView({block:'nearest'});}return;
      }
      // Persist even hydrated values before navigating; the cart remains the original cart.
      revision++;await flush();
      (window.CoriaCommerce && CoriaCommerce.track('checkout_start',{mode:'invoice'}),location.assign(checkoutUrl()));
    }catch(_){message('Datele nu au fost salvate. Verifică conexiunea și apasă din nou Finalizează comanda.',true);}
    finally{checkoutBusy=false;btn.removeAttribute('aria-busy');if(btn.tagName==='BUTTON'||btn.tagName==='INPUT')btn.disabled=false;}
  }
  document.addEventListener('click',function(e){var btn=e.target.closest(selector);if(!isCheckout(btn)||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;if(!hasData()&&!saving&&revision<=savedRevision)return;e.preventDefault();e.stopImmediatePropagation();checkout(btn);},true);
  document.addEventListener('submit',function(e){var btn=e.submitter;if(!isCheckout(btn)||(!hasData()&&!saving&&revision<=savedRevision))return;e.preventDefault();e.stopImmediatePropagation();checkout(btn);},true);
  var scheduled=false;
  new MutationObserver(function(ms){if(scheduled||!ms.some(function(m){return Array.from(m.addedNodes).some(function(n){return n.nodeType===1&&(n.matches(selector)||!!n.querySelector(selector));});}))return;scheduled=true;requestAnimationFrame(function(){scheduled=false;place();});}).observe(document.body,{childList:true,subtree:true});
  window.CoriaInvoice={flush:flush,valid:valid,place:place};place();
})();
